import {queryToString, appendQuery, inView, getEventPath} from './util';
import {forEach, filter, map} from 'lodash';

// 参数示例
// const options = {
//     url: '',
//     list: [{
//         event: 'expose',
//         el: '',
//         callback: function (e, num) {
//         }
//     }, {
//         event: 'click',
//         el: '',
//         callback: function (e, num) {
//         }
//     }, {
//     }]
// };
function request(_url, params) {
    const query = queryToString(params);
    const url = appendQuery(_url, query);
    (new Image()).src = url;
}


function Monitor(options) {
    options = options || {};
    this.url = options.url;
    this.status = false;
    this.exposeListener = [];
    this.clickListener = [];
    this.update(options.list);
}
const initBaseInfo = function () {
    return {
        enterViewNum: 0,
        leaveViewNum: 0,
        clickNum: 0,
        time: 0,
        status: null,
        prevTime: 0,
        prevStatus: null
    };
};
const updateStatus = function (monitor, status) {
    monitor.prevStatus = monitor.status;
    monitor.prevTime = monitor.time;
    monitor.status = status;
    monitor.time = Date.now();
    if (status === 'enter') {
        monitor.enterViewNum++;
    }
    if (status === 'leave') {
        monitor.leaveViewNum++;
    }
    if (status === 'click') {
        monitor.clickNum++;
    }
};
Monitor.send = function (url, params) {
    request(url, params || {});
};
Monitor.scrollEventQueue = [];
Monitor.scrollEventStatus = false;
Monitor.scrollEventListener = function (e) {
    forEach(Monitor.scrollEventQueue, function (scrollFn) {
        try {
            scrollFn(e);
        } catch (e) {
            console.error(e);
        }
    });
};
Monitor.addScrollEvent = function (fn) {
    Monitor.scrollEventQueue.push(fn);
    if (!Monitor.scrollEventStatus) {
        window.addEventListener('scroll', Monitor.scrollEventListener);
        Monitor.scrollEventStatus = true;
    }
    // 新增监听时手动执行一次, 查看当前视口是否有露出
    fn();
};

Monitor.removeScrollEvent = function (fn) {
    Monitor.scrollEventQueue = filter(Monitor.scrollEventQueue, item => item !== fn);
    if (!Monitor.scrollEventQueue.length) {
        window.removeEventListener('scroll', Monitor.scrollEventListener);
        Monitor.scrollEventStatus = false;
    }
};


Monitor.exposedListener = function (e, _options) {
    const {list, url} = _options; 
    forEach(list, item => {
        const {monitor, options} = item;
        let {el, event} = options;
        if (typeof el === 'string') {
            el = document.querySelector(el);
        }
        if (event !== 'expose' || !el) {
            return;
        }
        const exposed = inView(el);
        if (monitor.status !== 'enter' && exposed) {
            updateStatus(monitor, 'enter');
        } else if (monitor.status === 'enter' && !exposed) {
            updateStatus(monitor, 'leave');
        } else {
            return;
        }
        if (!options.callback) {
            request(url);
            return;
        }
        const params = options.callback({
            event: e, 
            options,
            monitor
        });
        if (params === false) {
            return;
        }
        request(url, params || {});
    });
};


Monitor.clickEventQueue = [];
Monitor.clickEventStatus = false;
Monitor.clickEventListener = function (e) {
    forEach(Monitor.clickEventQueue, function (clickFn) {
        try {
            clickFn(e);
        } catch (e) {
            console.error(e);
        }
    });
};
Monitor.addClickEvent = function (fn) {
    Monitor.clickEventQueue.push(fn);
    if (!Monitor.clickEventStatus) {
        document.body.addEventListener('click', Monitor.clickEventListener);
        Monitor.clickEventStatus = true;
    }
};
Monitor.removeScrollEvent = function (fn) {
    Monitor.clickEventQueue = filter(Monitor.clickEventQueue, item => item !== fn);
    if (!Monitor.clickEventQueue.length) {
        window.body.removeEventListener('click', Monitor.clickEventListener);
        Monitor.clickEventStatus = false;
    }
};
Monitor.clickListener = function (e, _options) {
    const {url, list} = _options;
    const path = getEventPath(e);
    forEach(list, item => {
        const {monitor, options} = item;
        let {el, event} = options;
        if (typeof el === 'string') {
            el = document.querySelector(el);
        }
        if (event !== 'click' || !filter(path, pathItem => pathItem === el).length) {
            return;
        }
        updateStatus(monitor, 'click');
        if (!options.callback) {
            request(url);
            return;
        }
        const params = options.callback({
            event: e,
            options,
            monitor
        });
        if (params === false) {
            return;
        }
        request(url, params || {});
    });
};

Monitor.exposedMonitor = function (_options) {
    _options = _options || {};
    const options = {
        url: _options.url,
        list: map(_options.list, item => {
            return {
                monitor: initBaseInfo(),
                options: item
            };
        })
    };
    function listener(e) {
        Monitor.exposedListener(e, options);
    }
    Monitor.addScrollEvent(listener);
    return function () {
        Monitor.removeScrollEvent(listener);
    };
};

Monitor.clickMonitor = function (_options) {
    _options = _options || {};
    const options = {
        url: _options.url,
        list: map(_options.list, item => {
            return {
                monitor: initBaseInfo(),
                options: item
            };
        })
    };
    function listener(e) {
        Monitor.clickListener(e, options);
    }
    Monitor.addClickEvent(listener);
    return function () {
        Monitor.removeClickEvent(listener);
    };
};

Monitor.prototype.update = function (_list = []) {
    const url = this.url;
    const list = {};
    forEach(_list, item => {
        if (!list[item.event]) {
            list[item.event] = [];
        }
        list[item.event].push({
            monitor: initBaseInfo(),
            options: item
        });
    });
    if (list.expose) {
        function exposeListener(e) {
            Monitor.exposedListener(e, {
                url,
                list: list.expose
            });
        };
        this.exposeListener.push({
            list: list.expose,
            listener: exposeListener
        });
        Monitor.addScrollEvent(exposeListener);
    } 
    if (list.click) {
        function clickListener(e) {
            Monitor.clickListener(e, {
                url,
                list: list.click
            });
        };
        this.clickListener.push({
            list: list.click,
            listener: clickListener
        });
        Monitor.addClickEvent(clickListener);
    }
    this.status = this.status || true;
};

Monitor.prototype.send = function (params) {
    request(this.url, params || {});
};

Monitor.prototype.stop = function () {
    forEach(this.exposeListener, item => {
        Monitor.removeScrollEvent(item.listener);
    });
    forEach(this.clickListener, item => {
        Monitor.removeClickEvent(item.listener);
    });
    this.status = false;
};

export default Monitor;